<div class="close">
  <button (click)="close()">
    <img
      alt="close"
      width="20"
      height="20"
      src="../../../assets/images/close.svg"
    />
  </button>
</div>
<div class="title">规则明细</div>
<div class="content">
  <div class="item">
    <div class="item-title">邀请链接绑定规则：</div>
    <div class="item-content">
      <div class="item-subtitle">1. 通过邀请链接注册：</div>
      <div class="item-text">
        使用他人提供的邀请链接注册后，您的账户将自动绑定邀请人。
      </div>
      <div class="item-subtitle">2. 直接通过官网注册：</div>
      <div class="item-text">
        如果您末使用邀请链接直接通过官网注册，将不会绑定任何邀请人。
      </div>
      <div class="item-subtitle">3. 末签约过的邀请链接规则：</div>
      <div class="item-text">
        若使用的邀请链接尚末签约，分成比例为首笔订单实付金额的
        10%，后续订单不计算。
      </div>
    </div>
  </div>
  <div class="item">
    <div class="item-title">优惠码使用规则：</div>
    <div class="item-content">
      <div class="item-subtitle">1. 有邀请人时使用优惠码：</div>
      <div class="item-text">
        如果您已经绑定了邀请人并在下单时使用优惠码，该订单将计入 优惠码拥有者
        名下，但您的邀请人绑定关系 不会被修改。
      </div>
      <div class="item-subtitle">2. 无邀请人时使用优惠码：</div>
      <div class="item-text">
        如果您末绑定邀请人，在下单时使用了优惠码，则该订单和您的账户将计入
        优惠码拥有者 名下，同时该优惠码拥有者将成为您的邀请人。
      </div>
      <div class="item-subtitle">3. 九折优惠码：</div>
      <div class="item-text">
        仅限新用户 第一单使用，帮助您的朋友或粉丝享受首单优惠。
      </div>
    </div>
  </div>
  <div class="item">
    <div class="item-title">订单佣金规则：</div>
    <div class="item-content">
      <div class="item-subtitle">1. 冻结期规则：</div>
      <div class="item-text">
        通过推荐产生的订单，将会
        七天。在此期间，如果出现订单退款的情况，相应佣金将会被扣除。
      </div>
      <div class="item-subtitle">2. 解冻及提现：</div>
      <div class="item-text">
        订单完成后 七天，佣金将自动解冻。<br />
        解冻后，佣金可以自由提现至支付宝，没有最低金额限制。
      </div>
    </div>
  </div>
  <div class="button">
    <button (click)="close()">确认</button>
  </div>
</div>
